import React from 'react';
import { Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { StepsLoading } from 'pages/public/Loading';
import NotFoundPage from 'pages/public/NotFoundPage';

import BDOTransferRequest from '../transfer-requests/BDOTransferRequest';
import BDOPointsRedemptions from './BDOPointsRedemptions';

const PointsRedemptions = () => {
  return (
    <Suspense fallback={<StepsLoading />}>
      <Routes>
        <Route index element={<Navigate to="list" replace />} />
        <Route path="list" element={<BDOPointsRedemptions />} />
        <Route path="show/:id" element={<BDOTransferRequest />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Suspense>
  );
};

export default PointsRedemptions;
